<template>
  <d-modal
    :modal="modal"
    :title="$t('change-password.page-heading')"
    @submitModal="handleSubmitModal"
    @closeModal="handleCloseModal"
    :isSubmitting="isSubmitting"
  >
    <template slot="body">
      <v-row class="mb-1">
        <v-col cols="12" class="mb-3">
          <v-text-field
            :label="$t('change-password.form.old-password')"
            hide-details="auto"
            filled
            v-model.trim="form.oldPassword"
            :rules="rule.oldPassword"
            :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showOldPassword ? 'text' : 'password'"
            @click:append="showOldPassword = !showOldPassword"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="mb-3">
          <v-text-field
            :label="$t('change-password.form.password')"
            hide-details="auto"
            filled
            v-model.trim="form.password"
            :rules="rule.password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="mb-3">
          <v-text-field
            :label="$t('change-password.form.confirm-password')"
            hide-details="auto"
            filled
            v-model="form.passwordConfirmation"
            :rules="rule.passwordConfirmation"
            :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPasswordConfirmation ? 'text' : 'password'"
            @click:append="showPasswordConfirmation = !showPasswordConfirmation"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
  </d-modal>
</template>
    
<script>
import { changeMyPassword } from "@/services/auth";

const initialForm = {
  oldPassword: null,
  password: null,
  passwordConfirmation: null,
};

export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    item: Object,
  },
  data() {
    return {
      isSubmitting: false,
      form: { ...initialForm },
      rule: {
        oldPassword: [(v) => !!v || this.$t("defaults.rules.required")],
        password: [
          (v) => !!v || this.$t("defaults.rules.required"),
          (v) =>
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/.test(v) ||
            this.$t("change-password.rules.password-invalid"),
          (v) => {
            if (v != this.form.oldPassword) return true;

            return this.$t(
              "change-password.rules.password-is-same-old-password"
            );
          },
        ],
        passwordConfirmation: [
          (v) => !!v || this.$t("defaults.rules.required"),
          (v) => {
            if (!this.form.password) return true;

            if (v == this.form.password) return true;

            return this.$t("change-password.rules.confirm-password-not-match");
          },
        ],
      },
      showOldPassword: false,
      showPassword: false,
      showPasswordConfirmation: false,
    };
  },
  methods: {
    async handleSubmitModal() {
      await this.submitChangePassword();
    },
    async submitChangePassword() {
      try {
        this.isSubmitting = true;
        await changeMyPassword(this.form);

        this.$eventBus.$emit("notification", {
          type: "success",
          message: this.$t("change-password.alert.updated"),
        });
        this.$emit("submitModal");
      } catch (error) {
        if (error.response.data.code === "CORE_ACC_INVALID_PASSWORD_ERROR") {
          this.$eventBus.$emit("notification", {
            type: "error",
            message: this.$t("change-password.alert.invalid-old-password"),
          });
        } else
          this.$eventBus.$emit("notification", {
            type: "error",
            message: this.$t("defaults.text.request-error"),
          });
      } finally {
        this.isSubmitting = false;
      }
    },
    handleCloseModal() {
      this.$emit("closeModal");
    },
  },
};
</script>
    